<template>
	<div class="bg-documentGray" :class="isScroll ? 'h-full': ''">
		<FilePopup v-if="isFilePriview" v-bind:filedata="filePriviewData" @closePopup="closePopup" ></FilePopup>
		<TopAppBar
			:leftBtnMode="leftBtnMode"
			:rightBtnMode="rightBtnMode"
			:title="title"
			:leftBtnMethod="leftBtnMethod"
			:rightBtnMethod="rightBtnMethod"
			staticMode="true"
		>
		</TopAppBar>
		<div class="d-flex flex-column">
			<TopAppBarDrawer></TopAppBarDrawer>
			<main class="main-wrapper flex-grow-1"  v-if="!isFilePriview">
			<div class="d-flex align-items-center bg-white fix-header-title">
					<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center ">
						{{boardName}}
					</div>
			</div>
			<div class="divider"></div>
			<div class="shadow2 bg-white fix-header-title-content">
				<div class="container container--narrow pdt-14 pdb-14" v-if="mamberData">
					<div class="d-flex w-full justify-content-between">
						<div class="d-flex align-items-center flex-grow-1">
								<img v-if="mamberData.profile" :src="mamberData.profile"
								class="circle profile" :alt="mamberData.name.fullName">
								<div v-else v-html="firstCharOfNames" :style="bgColorOfName" class="circle profile min-w-40 h-40 user-name-profile"></div>
								<div class="t-subtitle6 mgb-1 font-r mgl-16 t-color-headlineBlack font-r">
										{{ mamberData.name?$t('3437',{first: mamberData.name.first, last: mamberData.name.last}):''}}
								</div>

						</div>
						<div class="d-flex ">
							<router-link tabindex="0"  :to="{name: 'SocialLearning',params: {board:boardId},query:{boardName:boardName}}"
								class="mdc-button  d-flex flex-column pdt-32 myPostBtn mgr-8">
								<div class="mdc-button__ripple custom-ripple"></div>
								<span class="mdc-button__label t-body3 t-color-iconInactive font-r"> {{ $t('3061') }}</span>
							</router-link>
							<button class="mdc-button  d-flex flex-column pdt-32 writePostBtn" @click="changeRoute" @keypress="changeRoute" v-if="selectedChild && selectedChild.register === true" tabindex="0">
								<div class="mdc-button__ripple custom-ripple"></div>
								<span class="mdc-button__label t-body3 t-color-iconInactive font-r">{{ $t('1429') }}</span>
							</button>
						</div>
					</div>
				</div>
			</div>
			<SocialLearningNoData v-if="isNoData"></SocialLearningNoData>
		<div class="container container--narrow pdt-30 pdb-26" v-else>
      <SocialLearningComponent :boardListData="listData"></SocialLearningComponent>
			<infinite-loading @infinite="fetchData" :identifier="infiniteId" spinner="spiral">
				<div slot="no-more" class="mgt-16"></div>
				<div slot="no-results" class="mgt-16"></div>
			</infinite-loading>
		</div>
		</main>
		</div>
	</div>
</template>
<script>
/**
 * 나의 학습 목록 메인 컴포넌트(social learning list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCTopAppBar } from "@material/top-app-bar";
import { MDCRipple } from "@material/ripple";
import socialApi from "@/api/socialApi.js";
import SocialLearningNoData from "./SocialLearningNoData.vue";
import SocialLearningComponent from "@/components/common/SocialLearningComponent.vue";
import InfiniteLoading from "vue-infinite-loading";

import { topAppBarMixin } from "../../mixins/topAppBar.js";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import TopAppBar from "../TopAppBar.vue";
import FilePopup from "./FilePopup";

export default {
	components: {
		SocialLearningNoData,
    SocialLearningComponent,
		InfiniteLoading,
		TopAppBar,
		TopAppBarDrawer,
		FilePopup
	},
	data: function() {
		return {
			isDrawerOpen: false,
			mamberData: [],
			contents: "",
			status: "",
			isNoData: false,
			campaignData: null,
			listData: [],
			currentPage: 1,
			totalPages: 1,
			infiniteId: +new Date(),
			filePriviewData:[],
			isFilePriview:false,
			selectedChild : null,
			boardId:'',
			boardName:'',
			boardData:null,
			title:localStorage.getItem('brandName'),
			firstCharOfNames : localStorage.getItem('firstChar'),
      		bgColorOfName : localStorage.getItem('bgColors'),
			  isScroll: false
		};
	},
	mixins: [topAppBarMixin],
	watch: {
		$route(to, from) {
			this.boardId =  this.$route.query.board
			this.boardName =  this.$route.query.boardName
			this.initData();
		}
	},
	mounted() {
		if ($(document).height() < $(window).height()) {
      	this.isScroll = true;
		}

		this.setMaterialUi()
			this.boardId =  this.$route.query.board
			this.boardName =  this.$route.query.boardName
			socialApi
							.boardAuth(this.boardId)
							.then(response => {
								this.boardData = response.data.data;
								//console.log('boare auth data watch',this.boardData);
								socialApi
									.fetchMember()
									.then(response => {
										this.mamberData = response.data.data;
										let myId = this.mamberData.responsibilityId
										//console.log('this.boards[0]',this.boards[0])
										//this.boards[0].authPermission.forEach(permission => {
										let permissionData = this.boardData.authPermission.find(child => child.partId == myId)
										if(permissionData) {
											this.selectedChild = permissionData
										}
										//console.log('eeeeeeee',this.selectedChild)
									// })

									})
									.catch(err => {
										$state.error();
									});
							})
							.catch(err => {
								$state.error();
							});
			this.setTopAppBarBackSearch(localStorage.getItem('brandName'));
	},
	methods: {
		setMaterialUi() {
						const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
								let button = new MDCRipple.attachTo(el)
								return button
						})
				},
		goBackPreviousPage() {
			 this.$router.push('/socialLearning/'+this.boardId+"?boardName="+this.boardName);
		},
		changeRoute(){
			if(this.boardData.userBbsToDayAuth){
				this.$router.push('/social-learning/write?board='+this.boardId+"&boardName="+this.boardName);
			}else{
				this.$alert({
						//title: this.$t('779'), //가입 승인 대기 상태입니다.
						content: this.$t('3064'),
						accept:  this.$t('3065')
				}).then(() => {}).catch(() => {})
			}

		},
		priviewFiel(file){
			this.filePriviewData = file;
			this.isFilePriview = true;
		},
		closePopup(){
			this.filePriviewData = Array();
			this.isFilePriview = false;
		},
		 listFilter(str){

			let length = 160;
			let ending = ' ...';
			let str1='';
			if (str.length > length) {
				str1 = str.substring(0, length - ending.length) + ending;
				return str1.replace(/(\r\n|\n|\r)/gm, '<br/>')
			} else {
				return str.replace(/(\r\n|\n|\r)/gm, '<br/>');
			}
		},
		// method to redirect the user on Detail page if exists
		moveToDetail(record) {
			if (record && record.id) {
				this.$router.push('/socialLearning/'+this.boardId+'/'+record.id+'?boardName='+encodeURI(this.boardName))
				//this.$router.push('/socialLearning/'+record.id+'?board='+this.boardId+'&boardName='+encodeURI(this.boardName))
				// this.$router.push({
				//   name: "SLDetail",
				//   params: {
				//     postId: record.id
				//   }
				// });
			}
		},
		initData() {
			this.listData = [];
			this.currentPage = 1;
			this.totalPages = 1;
			this.infiniteId += 1;
		},
		fetchData($state) {
			let responseData = null;
			let params = this.setParams();

			if (this.totalPages >= this.currentPage) {
				socialApi
					.fetchList(params,this.boardId)
					.then(response => {
						responseData = response.data.data;
						_.map(responseData.content, o => {
							o.progressViewStatus = false;
						});

						this.listData = this.listData.concat(responseData.content);
						this.currentPage++;
						this.totalPages = responseData.totalPages;
						if (responseData.content.length) {
							//let item = this.listData.find(item => item.auditor.register.id === this.mamberData.id);
							// print
							let myId = this.mamberData.responsibilityId

							this.listData[0].boardDto.authPermission.forEach(permission => {
							let permissionData = permission.child.find(child => child.partId == myId)
							if(permissionData) {
							this.selectedChild = permissionData
							}
							})
						}
						if (responseData.content.length) {
							$state.loaded();
						} else {
							$state.complete();
						}

						if (this.listData.length > 0) {
							this.isNoData = false;
						} else {
							this.isNoData = true;
						}
					})
					.catch(err => {
						$state.error();
					});
			} else {
				$state.complete();
			}
		},

		// 파라미터 설정(set parameter)
		setParams() {
			let params = {
				type:'MINE',
				sort: "id,desc",
				//contents: encodeURI(this.contents),
				page:this.currentPage
			};
			return params;
		},
		// Open drawer
		openDrawer() {
			this.isDrawerOpen = true;
		},
		// Close drawer
		closeDrawer() {
			this.isDrawerOpen = false;
		},
		searchOpen() {
			$(".search_box").show();
			$(".sm_star").addClass("backBg");
		},
		searchClose() {
			$(".search_box").hide();
			$(".sm_star").removeClass("backBg");
		},
		search() {
			let responseData = null;
			let params = this.setParams();
			socialApi
				.fetchList(params)
				.then(response => {
					responseData = response.data.data;
					// _.map(responseData.content, (o) => {
					//   o.progressViewStatus = false;
					// });

					this.listData = responseData.content;

					$(".search_box").hide();
					$(".sm_star").removeClass("backBg");
				})
				.catch(err => {
					$(".search_box").hide();
					$(".sm_star").removeClass("backBg");
					$state.error();
				});
		},
		patchLikeState(id, status,record) {
			this.$showLoading();
			let action = status
				? socialApi.patchPostLike(this.boardId, id)
				: socialApi.patchPostDislike(this.boardId, id);

			action
				.then(response => {
					this.$hideLoading();
					record.likesCount = response.data.data.likesCount;
					//this.detail.like = !status;
				})
				.catch(err => {
					this.$error({ content: err.errMsg }).then(() => {});
				});
		},
	}
};
</script>

<style scoped>
/* reset */

</style>
